import { FC } from "react";
import { MessageBarType } from "@fluentui/react";
import { IMessageBar, MessageBar, MessageBarTypeExtended, Separator } from "cayo.ui";
import styled from "styled-components";
import { IScheme } from "@cayo/shared/api/types/schema";
import customFormRenderers from "./custom-form.renderers";
import formatterControls from "./formatter.renderers";
import { layoutRenderers } from "./renderers.layout";
import userControlRenderers from "./user-control.renderers";
import { IPivot } from "../../../api/schema.api";
import cardsRenderers from "../../Cards";
import chartRenderers from "../../Charts";
import formRenderers from "../../Form/renderers/form-renderers";
import { buttonRenderers } from "../../Form/renderers/renderers.buttons";
import { PlanInfo } from "../../Freemium";
import graphicsRenderers from "../../Graphics";
import listRenderers from "../../Lists/lists.renderers";
import Pivot from "../../Navigation/Pivot";
import surfaceRenderers from "../../Surfaces";
import Spacer from "../../Utilities/Spacer";
import widgetRenderers from "../../Widgets";
import GenericScheme from "../GenericScheme";

const Scheme: FC<IScheme> = (props: IScheme) => {
  return <GenericScheme {...(props as any)} />;
};

const Pixels: FC = (props: any) => {
  return <PixelsContainer width={props.width} />;
};

const separator: FC = (props) => {
  return <Separator {...props} />;
};

const App = (props: IScheme) => {
  return <AppContainer>{allRendereres.scheme(props)}</AppContainer>;
};

const pivot = (props: IPivot) => {
  return <Pivot {...(props as any)} />;
};

const navigationRendereres = {
  pivot,
};

const messagebar = (props: IMessageBar) => {
  const messageBarType = MessageBarType[
    props.messageBarType as unknown as MessageBarType
  ] as MessageBarTypeExtended;

  return <MessageBar {...props} messageBarType={messageBarType} />;
};

const notificaitionsRendereres = {
  messagebar,
};

export const allRendereres = {
  ...customFormRenderers,
  ...layoutRenderers,
  ...buttonRenderers,
  ...widgetRenderers,
  ...chartRenderers,
  ...listRenderers,
  ...cardsRenderers,
  ...userControlRenderers,
  ...graphicsRenderers,
  ...surfaceRenderers,
  ...formatterControls,
  ...navigationRendereres,
  ...notificaitionsRendereres,
  ...formRenderers,
  separator,
  scheme: Scheme,
  spacer: Spacer,
  pixels: Pixels,
  planinfo: PlanInfo,
  app: App,
};

export const PixelsContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
`;

const AppContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export type rendererNames = keyof typeof allRendereres;
